/**
 * LD product grid — AJAX add to cart (sections/ld-product-grid.liquid).
 * Scoped per section so multiple instances on a page work independently.
 */
(function () {
  function initSection(section) {
    var toast = section.querySelector('[data-ld-toast]');
    var toastTitle = toast && toast.querySelector('[data-ld-toast-title]');
    var toastSubtitle = toast && toast.querySelector('[data-ld-toast-subtitle]');
    var hideTimer;

    function showToast(title, subtitle) {
      if (!toast) return;
      toastTitle.textContent = title;
      toastSubtitle.textContent = subtitle || '';
      toast.classList.add('is-on');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        toast.classList.remove('is-on');
      }, 4000);
    }

    section.querySelectorAll('[data-ld-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var originalText = btn.textContent;
        var variantId = btn.getAttribute('data-variant-id');
        var productTitle = btn.getAttribute('data-product-title') || 'Product';

        btn.textContent = 'Adding…';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(response);
          })
          .then(function () {
            showToast(productTitle, 'Added to your cart');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {
            showToast(productTitle, 'Something went wrong — try again');
          })
          .then(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          });
      });
    });
  }

  function init() {
    document.querySelectorAll('.ld-more').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();